// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getFirestore, query,
  getDocs,
  doc,
  collection,
  where,
  addDoc,
  setDoc,
  getDoc} from "firebase/firestore";
import { getAnalytics } from "firebase/analytics";
import { getStorage } from "firebase/storage";

import { GoogleAuthProvider, getAuth, signInWithPopup, signInWithEmailAndPassword,
  createUserWithEmailAndPassword, fetchSignInMethodsForEmail,
  sendPasswordResetEmail, updateProfile,
  signOut, updateEmail,
  } from "firebase/auth";

  const firebaseConfig = {
    apiKey: "AIzaSyDPxI78yL61rTJMxJgP1MQ5wGqWUVT5FlI",
    authDomain: "profilecard-721c7.firebaseapp.com",
    projectId: "profilecard-721c7",
    storageBucket: "profilecard-721c7.appspot.com",
    messagingSenderId: "497692351843",
    appId: "1:497692351843:web:e734c6de91429b6d558756",
    measurementId: "G-NPVBPZDEQ6"
  };

const app = initializeApp(firebaseConfig);
const db = getFirestore(app);
const storage = getStorage(app);
const auth = getAuth(app);
const googleProvider = new GoogleAuthProvider();

// const signInWithGoogle = async (storeID) => {
//   try {
//     const res = await signInWithPopup(auth, googleProvider);
//     const user = res.user;
//     const q = query(collection(db, "stores/" + storeID + "/users"), where("uid", "==", user.uid));
//     const docs = await getDocs(q);
//     if (docs.docs.length === 0) {
//       await addDoc(collection(db, "stores/" + storeID + "/users"), {
//         uid: user.uid,
//         authProvider: "google",
//         email: user.email,
//       });
//     }
//   } catch (err) {
//     console.error(err);

//   }
// };

const logInWithEmailAndPassword = async (email, password) => {
  try {

    // const q = query(collection(db, "stores/" + storeID + "/users"), where("email", "==", email), where("active", "==", true));
    // const docs = await getDocs(q);
    // if (docs.docs.length === 0) {
    //   return "You have entered an incorrect username and password."
    // }
    /*
    else {
      docs.forEach(doc => {
        const displayName = doc.data().name;
        localStorage.setItem("displayName", displayName);
      })
    }
    */

    await signInWithEmailAndPassword(auth, email, password)
    return {
      status: 200,
      message: "success"
    }
    //localStorage.setItem("store", storeID);
  } catch (err) {
    return {
      status: 500,
      message: err.message
    }
  }
};

async function updateUserEmail(auth, newEmail) {
  await updateEmail(auth, newEmail);
}

const createUser = async (email, password) => {
    try {
      const signInMethods = await fetchSignInMethodsForEmail(auth, email);
      const userExists = Array.isArray(signInMethods) && signInMethods.length > 0;
  
      if (userExists) {
        console.log("User already exists");
        return 500;
        // Handle the case where the user already exists
      } else {
        const userDetails = await createUserWithEmailAndPassword(auth, email, password);
       // Create user profile with auto-generated ID
       const user = userDetails.user;

       const profilesRef = doc(db, "profiles", user.uid);

       await setDoc(profilesRef, { email, published: false });

        console.log("User created successfully");
        return 200;
        // Handle the case where the user is created successfully
      }
    } catch (error) {
      console.error("Error creating user:", error);
      return 400;
      // Handle any errors that occurred during user creation or checking
    }
  };


  


const createStoreDB = async (storeID) => {
  await setDoc(doc(db, "stores/" + storeID), {
    store: storeID
  })

  //console.log("Store created in db");

}

const sendPasswordReset = async (email) => {
  try {
    await sendPasswordResetEmail(auth, email);
    return {
      status: true, 
      message: "Your password reset instructions have been emailed to you."
    };
    
  } catch (err) {

    if(err.message === "Firebase: Error (auth/user-not-found).")
    {
      return {
        status: false,
        message: "You have entered an incorrect email."
      }
    }
    else return {
      status: false,
      message: err.message
    };
  }
};
const logout = () => {
  localStorage.removeItem("store")
  signOut(auth);
};

export {db, storage, auth, createStoreDB,
  logInWithEmailAndPassword,
  createUser,
  sendPasswordReset, updateUserEmail,
  logout};